import type { QuestionTypeOption } from './DynamicDTOs';

export const DynamicQuizOptionsG2: QuestionTypeOption[] = [
    {
        id: 2001,
        standards: ['2.NBT.4'],
        variants: [
            {
                id: 1,
                name: 'Comparing - Standard to Standard',
                route: 'numberCompare',
                params: {
                    leftMin: 1,
                    leftMax: 999,
                    leftDisplayModes: [1],
                    rightMin: 1,
                    rightMax: 999,
                    rightDisplayModes: [1],
                },
            },
            {
                id: 2,
                name: 'Comparing - Standard to Expanded',
                route: 'numberCompare',
                params: {
                    leftMin: 1,
                    leftMax: 999,
                    leftDisplayModes: [1],
                    rightMin: 1,
                    rightMax: 999,
                    rightDisplayModes: [2],
                },
            },
        ],
    },
    {
        id: 2002,
        standards: ['2.NBT.1a'],
        variants: [
            {
                id: 1,
                name: 'Hundreds to Tens',
                route: 'tensHundreds',
                params: {
                    minTens: 10,
                    maxTens: 100,
                    mode: 1,
                },
            },
            {
                id: 2,
                name: 'Tens to Hundreds',
                route: 'tensHundreds',
                params: {
                    minTens: 10,
                    maxTens: 100,
                    mode: 2,
                },
            },
        ],
    },
    {
        id: 2003,
        standards: ['2.NBT.1b'],
        variants: [
            {
                id: 1,
                name: 'Hundreds to Ones',
                route: 'hundredsOnes',
                params: {
                    minOnes: 100,
                    maxOnes: 1000,
                    mode: 1,
                },
            },
            {
                id: 2,
                name: 'Ones to Hundreds',
                route: 'hundredsOnes',
                params: {
                    minOnes: 100,
                    maxOnes: 1000,
                    mode: 2,
                },
            },
        ],
    },
    {
        id: 2004,
        standards: ['2.NBT.3'],
        variants: [
            {
                id: 1,
                name: 'Standard to Expanded',
                route: 'numberForms',
                params: {
                    type: 1,
                    minNumber: 0,
                    maxNumber: 999,
                },
            },
            {
                id: 2,
                name: 'Expanded to Standard',
                route: 'numberForms',
                params: {
                    type: 2,
                    minNumber: 0,
                    maxNumber: 999,
                },
            },
            {
                id: 3,
                name: 'Standard to Word',
                route: 'numberForms',
                params: {
                    type: 3,
                    minNumber: 0,
                    maxNumber: 999,
                },
            },
        ],
    },
    {
        id: 2005,
        standards: ['2.OA.1'],
        variants: [
            {
                id: 1,
                name: 'Two Step Word Problem',
                route: 'twoStepWordProblem',
                params: {
                    type: 1,
                    initialValueMin: 1,
                    initialValueMax: 20,
                    addMin: 1,
                    addMax: 10,
                    answerMin: 0,
                    answerMax: 100,
                },
            },
            {
                id: 2,
                name: 'Addition Word Problem',
                route: 'addWordProblem',
                params: {
                    type: 1,
                    maxSum: 100,
                },
            },
            {
                id: 3,
                name: 'Subtraction Word Problem',
                route: 'subWordProblem',
                params: {
                    type: 1,
                    maxSum: 99,
                },
            },
        ],
    },
    {
        id: 2006,
        standards: ['2.NBT.8'],
        variants: [
            {
                id: 1,
                name: '10 More',
                route: 'moreLess',
                params: {
                    type: 1,
                    baseMin: 100,
                    baseMax: 999,
                    amountToAdd: 10,
                    answerMin: 0,
                    answerMax: 9999,
                },
            },
            {
                id: 2,
                name: '100 More',
                route: 'moreLess',
                params: {
                    type: 1,
                    baseMin: 100,
                    baseMax: 999,
                    amountToAdd: 100,
                    answerMin: 0,
                    answerMax: 9999,
                },
            },
            {
                id: 3,
                name: '10 Less',
                route: 'moreLess',
                params: {
                    type: 2,
                    baseMin: 100,
                    baseMax: 999,
                    amountToAdd: 10,
                    answerMin: 0,
                    answerMax: 9999,
                },
            },
            {
                id: 4,
                name: '100 Less',
                route: 'moreLess',
                params: {
                    type: 2,
                    baseMin: 100,
                    baseMax: 999,
                    amountToAdd: 100,
                    answerMin: 0,
                    answerMax: 9999,
                },
            },
        ],
    },
    {
        id: 2007,
        standards: ['2.NBT.5'],
        variants: [
            {
                id: 1,
                name: 'Two-Digit Addition',
                route: 'add',
                params: {
                    displayMode: 1,
                    type: 1,
                    firstMin: 1,
                    firstMax: 99,
                    secondMin: 1,
                    secondMax: 99,
                    sumMax: 100,
                },
            },
        ],
    },
    {
        id: 2008,
        standards: ['2.NBT.6'],
        variants: [
            {
                id: 1,
                name: 'Adding Multiple Numbers',
                route: 'addMultiple',
                params: {
                    displayMode: 1,
                    type: 1,
                    addendMin: 1,
                    addendMax: 99,
                    numberOfAddends: 4,
                },
            },
        ],
    },
    {
        id: 2009,
        standards: ['2.NBT.7', '2.NBT.9'],
        variants: [
            {
                id: 1,
                name: 'Three-Digit Addition',
                route: 'add',
                params: {
                    displayMode: 2,
                    type: 1,
                    firstMin: 150,
                    firstMax: 899,
                    secondMin: 150,
                    secondMax: 899,
                    sumMax: 1000,
                },
            },
            {
                id: 2,
                name: 'Three-Digit Subtraction',
                route: 'subtract',
                params: {
                    displayMode: 2,
                    type: 1,
                    minuendMin: 100,
                    minuendMax: 1000,
                    minuendMIncrement: 1,
                    subtrahendMin: 100,
                    subtrahendMax: 1000,
                    subtrahendIncrement: 1,
                    differenceMin: 0,
                },
            },
        ],
    },
    {
        id: 2010,
        standards: ['2.MD.1'],
        variants: [
            {
                id: 1,
                name: 'Length Measurement Tools',
                route: 'lengthMeasurementTools',
                params: {},
            },
        ],
    },
    {
        id: 2011,
        standards: ['2.OA.4'],
        variants: [
            {
                id: 1,
                name: 'Addition Array',
                route: 'additionArray',
                params: {
                    maxRows: 5,
                    maxColumns: 5,
                },
            },
        ],
    },
    {
        id: 2012,
        standards: ['2.MD.5'],
        variants: [
            {
                id: 1,
                name: 'Addition Word Problem',
                route: 'measurementWordProblem',
                params: {
                    type: 1,
                    measure1Min: 21,
                    measure1Max: 40,
                    measure2Min: 1,
                    measure2Max: 20,
                    answerMin: 2,
                    answerMax: 100,
                },
            },
            {
                id: 2,
                name: 'Subtraction Word Problem',
                route: 'measurementWordProblem',
                params: {
                    type: 2,
                    measure1Min: 21,
                    measure1Max: 40,
                    measure2Min: 1,
                    measure2Max: 20,
                    answerMin: 1,
                    answerMax: 100,
                },
            },
        ],
    },
];
